<template>
  <v-row>
    <v-col cols="12">
      <v-card tile flat color="transparent">
        <v-card-title class="px-0 pt-0">
          <div class="headline">All tasks</div>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-fade-transition mode="out-in">
            <table-skeleton-loader v-if="loading.items" />

            <v-row v-else-if="tasks.length">
              <v-col cols="12">
                <tasks-table :tasks="tasks" />
              </v-col>
            </v-row>

            <v-row v-else>
              <v-col cols="12">
                <v-card width="100%" outlined>
                  <v-card-text>
                    <div class="title">No tasks found.</div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-fade-transition>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TableSkeletonLoader from '@/components/loading/TableSkeletonLoader'
import TasksTable from '@/components/tasks/common/TasksTable'

export default {
  name: 'Tasks',
  components: {
    TableSkeletonLoader,
    TasksTable
  },
  computed: {
    ...mapGetters('tasks', ['tasks', 'loading'])
  },
  methods: {
    ...mapActions('tasks', ['fetchTasks'])
  },
  created() {
    this.fetchTasks()
  }
}
</script>
